import { useState } from 'react'
import { Card, Paginate, Table } from 'components'
import { useGetQuery } from 'hooks'

export const AdminTags = () => {
  const [page, setPage] = useState({ page: 1, limit: 5 })

  const { data, setPath } = useGetQuery({
    url: `/admin/tags?limit=${page.limit}&offset=0`
  })

  const pageChange = (newPage) => {
    setPage(newPage)
    setPath(`/admin/tags?limit=${newPage.limit}&offset=${(newPage.page - 1) * newPage.limit}`)
  }

  if (!data?.tags) return <Card>no tags</Card>
  return (
    <Card>
      <Table
        data={data.tags.rows}
        columns={[{ title: 'Name', key: 'name' }]}
      />
      <Paginate onChange={pageChange} {...page} count={data.tags.count || 0} />
    </Card>
  )
}
